// extracted by mini-css-extract-plugin
module.exports = {"category_list":"CategoryList_category_list__vVM_U","link":"CategoryList_link__5o_zm"};